import { useCreateImage } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { noticeError } from "src/utils"

function fileToDataURL(file: File): Promise<string> {
  const promise = new Promise<string>((resolve) => {
    const fileReader = new FileReader()
    fileReader.addEventListener(
      "load",
      () => {
        resolve(fileReader.result as string)
      },
      false,
    )

    fileReader.readAsDataURL(file)
  })

  return promise
}

export function useUploadImage() {
  const createImage = useCreateImage()

  const uploadImage = useMemo(
    () => !createImage ? undefined : async (file: File) => {
      try {
        const dataURL = await fileToDataURL(file)
        const response = await createImage(dataURL)
        return response
      } catch (e) {
        noticeError(
          e,
          "CreateImage",
        )

        throw e
      }
    },
    [createImage],
  )

  return uploadImage
}
